var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9239 0.327657C10.4733 0.356718 10.0792 0.643061 9.91222 1.06231L7.51064 6.55555L1.43111 7.26096C0.96674 7.31348 0.577791 7.63659 0.442164 8.08322L0.441593 8.0851C0.306394 8.53156 0.4488 9.01538 0.804978 9.31764L5.47464 13.2789L4.42518 19.1819C4.33183 19.6249 4.50113 20.0819 4.86076 20.3558C5.22034 20.6297 5.70577 20.6728 6.10749 20.4654L11.5872 17.3321L17.2594 20.4979C17.6646 20.7062 18.1545 20.6604 18.5144 20.3798C18.7087 20.2284 18.8464 20.0226 18.9152 19.7956C18.9735 19.603 18.9826 19.3955 18.9352 19.1919L17.2501 13.1749L21.9902 9.1035C22.1427 8.9604 22.2502 8.7827 22.3085 8.59011C22.3771 8.36362 22.377 8.11756 22.2996 7.88386C22.157 7.45139 21.7764 7.14145 21.3243 7.08784L14.8448 6.57468L12.0222 0.924914C11.8027 0.530905 11.375 0.2982 10.9239 0.327657Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/StarIcon.f0ac811dd84edbee0384afbaf50f81f5.svg";
export { ForwardRef as ReactComponent };